export const ROOT = '/';
export const FORM = '/basvuru-olustur';
export const SUCCESS = '/basvuru-basarili';
export const CHECK = '/basvuru-sorgula';
export const CHECK_SPECIFIC = '/basvuru/:id';
export const ADMIN = '/admin';
export const LIST = '/admin/basvuru-listesi';
